import { createMainResourceREST, mergeSummaryBodyField } from '../resource';
import {
  CRStandardNoteBody,
  CRStandardNoteBodyAPI,
  CRStandardNoteKey,
  CRStandardNoteSummary,
  CRStandardNoteSummaryAPI,
  StandardNoteActions,
  StandardNotesState,
} from './types';

type AnyStandardNote =
  | CRStandardNoteKey
  | CRStandardNoteSummary
  | CRStandardNoteBody
  | undefined;

function sameKeyStandardNote(a: AnyStandardNote, b: AnyStandardNote): boolean {
  return a?.standardNoteId === b?.standardNoteId;
}

function getEndpointStandardNote(key: AnyStandardNote): string {
  return key ? `/standard-notes/${key.standardNoteId}/` : '/standard-notes/';
}

function parseStandardNoteSummary(
  standardNoteSummary: CRStandardNoteSummaryAPI,
): CRStandardNoteSummary {
  return standardNoteSummary;
}

function parseStandardNoteBody(
  standardNoteDetail: CRStandardNoteBodyAPI,
): CRStandardNoteBody {
  return standardNoteDetail;
}

const standardNotesStateSelector = (state: any): StandardNotesState =>
  state.standardNotes;

const standardNotesKeySelector = ({
  standardNoteId,
}: CRStandardNoteBody | CRStandardNoteSummary): CRStandardNoteKey => ({
  standardNoteId,
});

function mergeStandardNoteBody(
  lastBody: CRStandardNoteBody,
  currentBody: CRStandardNoteBody,
) {
  return currentBody;
}

function combineSummaryBodyStandardNote(
  summary?: CRStandardNoteSummary,
  body?: CRStandardNoteBody,
): CRStandardNoteSummary {
  const merge = mergeSummaryBodyField(summary, body);

  return {
    rowKey: merge('rowKey'),
    standardNoteId: merge('standardNoteId'),
    noteName: merge('noteName'),
    inUse: merge('inUse'),
    enabledForChild: merge('enabledForChild'),
    standardNoteType: merge('standardNoteType'),
    ownedBySite: summary?.ownedBySite ?? true,
  };
}

const { actions, reducer, watches } = createMainResourceREST(
  'standardNotes',
  getEndpointStandardNote,
  standardNotesStateSelector,
  sameKeyStandardNote,
  parseStandardNoteBody,
  parseStandardNoteSummary,
  mergeStandardNoteBody,
  combineSummaryBodyStandardNote,
  // formatStandardNoteBody,
  // validateStandardNoteTypes,
);

const standardNotesActions: StandardNoteActions = actions;
export * from './types';
export {
  standardNotesActions,
  reducer as standardNotesReducer,
  watches as standardNotesWatches,
  standardNotesStateSelector,
  standardNotesKeySelector,
};
